import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { updateFilter, resetFilters } from "..";

interface FilterUpdate {
  key: string;
  value: unknown;
}

interface GamificationFilterActions {
  updateFilter: (data: FilterUpdate) => void;
  resetFilters: () => void;
}

export const useGamificationFilterActions = (): GamificationFilterActions => {
  const dispatch = useDispatch();

  const update = useCallback(
    (data: FilterUpdate): void => {
      dispatch(updateFilter(data));
    },
    [dispatch],
  );

  const reset = useCallback((): void => {
    dispatch(resetFilters());
  }, [dispatch]);

  return { updateFilter: update, resetFilters: reset };
};
